import React from 'react';
import cx from 'classnames';
import './SortingVisualizer.css';
import {Link} from 'react-router-dom'
import styles from '../Mainpage/Mainpage.module.css';
import { getMergeSortAnimations } from './sortingAlgorithms/MergeSort';
import { getQuickSortAnimation } from './sortingAlgorithms/QuickSort';
import { getBubbleSortAnimations } from './sortingAlgorithms/BubbleSort';
import { getInsertionSortAnimation } from './sortingAlgorithms/InsertionSort';
import { getSelectionSortAnimations } from './sortingAlgorithms/SelectionSort';
import { getHeapSortAnimations } from './sortingAlgorithms/HeapSort';


const PRIMARY_COLOR = '#b08b3a';

const SECONDARY_COLOR = '#fff899';
var Disable = false;

export default class Sorting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      array: [],
      NUMBER_OF_ARRAY_BARS:50,
      ANIMATION_SPEED_MS:30,
      address : '/'

    };
  }

  
  resetArray() {
    if(Disable === false){
    const array = [];
    for (let i = 0; i < this.state.NUMBER_OF_ARRAY_BARS; i++) {
      array.push(randomIntFromInterval(5, 500));
    }
    this.setState({array});
  }
  }
  handleChange = (evt)=>{
    if(Disable === false){
    const num_bars = parseInt(evt.target.value);
    const array = [];
    for (let i = 0; i < num_bars; i++) {
      array.push(randomIntFromInterval(5, 500));
    }
    this.setState({
      array,
      NUMBER_OF_ARRAY_BARS:num_bars
    })
    const arrayBars = document.getElementsByClassName('array-bar');
    for(let i=0;i<arrayBars.length;i++){
      arrayBars[i].style.width = `${1000/num_bars}px`;
    }
  }
    
  }
  mergeSort() {
    if(Disable === false){
      Disable = true;
      const array1 = [];
      for(let i =0 ; i<this.state.array.length;i++){
        array1.push(this.state.array[i]);
      }
      this.setState({address:'/sort'});
    const animations = getMergeSortAnimations(array1);
    var time = (animations.length-1)*this.state.ANIMATION_SPEED_MS;
    setTimeout(()=>{
      Disable = false;
      this.setState({address:'/'});
    },time)
    for (let i = 0; i < animations.length; i++) {
      
      const arrayBars = document.getElementsByClassName('array-bar');
      const isColorChange = i % 3 !== 2;
      
      if (isColorChange) {
        
        const [barOneIdx, barTwoIdx] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;
        setTimeout(() => {
          
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
        
        }, i * this.state.ANIMATION_SPEED_MS);
      } 
      else {
        
        setTimeout(() => {
         
          const [barOneIdx, newHeight] = animations[i];
          const barOneStyle = arrayBars[barOneIdx].style;
          barOneStyle.height = `${newHeight}px`;
        
        }, i * this.state.ANIMATION_SPEED_MS);
      }
    }
  }
  }

  quickSort() {
    if(Disable === false){
      Disable = true;
    const array = [],array1=[];
    for(let i =0 ; i<this.state.array.length;i++){
      array.push(this.state.array[i]);
      array1.push(this.state.array[i]);
    }
      this.setState({address:'/sort'});
    const animations = getQuickSortAnimation(array1);
    var time = (animations.length-1)*this.state.ANIMATION_SPEED_MS;
    setTimeout(()=>{
      Disable = false;
      this.setState({address:'/'})
    },time)

    for (let i = 0; i < animations.length; i++) {

      const arrayBars = document.getElementsByClassName('array-bar');
      const isColorChange = i % 3 !== 2;

      if (isColorChange) {

        const [barOneIdx, barTwoIdx] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;

        setTimeout(() => {
        
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
        
        }, i * this.state.ANIMATION_SPEED_MS);
      } 
      else {
        
        setTimeout(() => {
          
          const [t,barOneIdx, barTwoIdx] = animations[i];
          const barOneStyle = arrayBars[barOneIdx].style;
          const barTwoStyle = arrayBars[barTwoIdx].style;
          const newHeight1 = array[barTwoIdx];
          const newHeight2 = array[barOneIdx];
          barOneStyle.height = `${newHeight1}px`;
          barTwoStyle.height = `${newHeight2}px`;
          const temp = array[barOneIdx];
          array[barOneIdx] = array[barTwoIdx];
          array[barTwoIdx] = temp;
         
       
        }, i * this.state.ANIMATION_SPEED_MS);
      }
    }  
  }
  }

  heapSort() {
    if(Disable === false){
      Disable = true;
      const array = [],array1=[];
      for(let i=0;i<this.state.array.length;i++){
        array.push(this.state.array[i]);
        array1.push(this.state.array[i]);
      }
      this.setState({address:'/sort'});
      const animations = getHeapSortAnimations(array1);
      
      var time = (animations.length-1)*this.state.ANIMATION_SPEED_MS;
      setTimeout(()=>{
        Disable = false;
        this.setState({address:'/'})
      },time);
      let flip = 0;
      for(let i=0;i<animations.length;i++){
        const arrayBars = document.getElementsByClassName('array-bar');
        if(animations[i][0]===1){
          const barOneIdx = animations[i][1] 
          const barTwoIdx = animations[i][2];
          const barOneStyle = arrayBars[barOneIdx].style;
          const barTwoStyle = arrayBars[barTwoIdx].style;
          const color = (flip == 0) ? SECONDARY_COLOR : PRIMARY_COLOR;
          flip = flip^1;
          setTimeout(()=>{

            barOneStyle.backgroundColor = color;
            barTwoStyle.backgroundColor = color;
          
          },i*this.state.ANIMATION_SPEED_MS);
        }
        else{
          setTimeout(()=>{
            const [t,barOneIdx, barTwoIdx] = animations[i];
          const barOneStyle = arrayBars[barOneIdx].style;
          const barTwoStyle = arrayBars[barTwoIdx].style;
          const newHeight1 = array[barTwoIdx];
          const newHeight2 = array[barOneIdx];
          barOneStyle.height = `${newHeight1}px`;
          barTwoStyle.height = `${newHeight2}px`;
          const temp = array[barOneIdx];
          array[barOneIdx] = array[barTwoIdx];
          array[barTwoIdx] = temp;
          },i*this.state.ANIMATION_SPEED_MS);
        }
      }
    } 
  }

  bubbleSort() {
    if(Disable === false){
      Disable = true;
    const array = [],array1=[];
    for(let i =0 ; i<this.state.array.length;i++){
      array.push(this.state.array[i]);
      array1.push(this.state.array[i]);
    }
    this.setState({address:'/sort'});
    const animations = getBubbleSortAnimations(array1);
    var time = (animations.length-1)*this.state.ANIMATION_SPEED_MS;
    setTimeout(()=>{
      Disable = false;
      this.setState({address:'/'})
    },time)

    for (let i = 0; i < animations.length; i++) {

      const arrayBars = document.getElementsByClassName('array-bar');
      const isColorChange = i % 3 !== 2;

      if (isColorChange) {

        const [barOneIdx, barTwoIdx] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;

        setTimeout(() => {
         
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
        
        }, i * this.state.ANIMATION_SPEED_MS);
      } 
      else {
       
        setTimeout(() => {
        
          const [t,barOneIdx, barTwoIdx] = animations[i];
          const barOneStyle = arrayBars[barOneIdx].style;
          const barTwoStyle = arrayBars[barTwoIdx].style;
          const newHeight1 = array[barTwoIdx];
          const newHeight2 = array[barOneIdx];
          barOneStyle.height = `${newHeight1}px`;
          barTwoStyle.height = `${newHeight2}px`;
          const temp = array[barOneIdx];
          array[barOneIdx] = array[barTwoIdx];
          array[barTwoIdx] = temp;
          
       
        }, i * this.state.ANIMATION_SPEED_MS);
      }
    }  
  }
  }
  insertionSort(){
    if(Disable === false){ 
      Disable = true;
      
    const array = [],array1=[];
    for(let i =0 ; i<this.state.array.length;i++){
      array.push(this.state.array[i]);
      array1.push(this.state.array[i]);
    }
    this.setState({address:'/sort'});
    const animations = getInsertionSortAnimation(array1);
    var time = (animations.length-1)*this.state.ANIMATION_SPEED_MS;
    setTimeout(()=>{
      Disable = false;
      this.setState({address:'/'})
    },time)
   
    for (let i = 0; i < animations.length; i++) {

      const arrayBars = document.getElementsByClassName('array-bar');
      const isColorChange = i % 3 !== 2;

      if (isColorChange) {

        const [barOneIdx, barTwoIdx] = animations[i];
        if(barOneIdx<0 || barTwoIdx<0){
          continue;
        }
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = i % 3 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;

        setTimeout(() => {
    
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
    
        }, i * this.state.ANIMATION_SPEED_MS);
      } 
      else {
    
        setTimeout(() => {
          const [type,barOneIdx, barTwoIdx] = animations[i];
          if(type === 1){
          const barOneStyle = arrayBars[barOneIdx].style;
          const newHeight1 = array[barTwoIdx];
          barOneStyle.height = `${newHeight1}px`;
          array[barOneIdx] = array[barTwoIdx];
          }
          else{
    
            const barOneStyle = arrayBars[barOneIdx].style;
            const newHeight1 = barTwoIdx;
            barOneStyle.height = `${newHeight1}px`;
            array[barOneIdx] = barTwoIdx;
    
          }
        }, i * this.state.ANIMATION_SPEED_MS);
      }
    }

  }
  }
  selectionSort(){
    if(Disable === false){
      Disable = true;
      
    const array = [],array1=[];
    for(let i =0 ; i<this.state.array.length;i++){
      array.push(this.state.array[i]);
      array1.push(this.state.array[i]);
    }
    this.setState({address:'/sort'});
    const animations = getSelectionSortAnimations(array1);
    var time = (animations.length-1)*this.state.ANIMATION_SPEED_MS;
    setTimeout(()=>{
      Disable = false;
      this.setState({address:'/'})
    },time)
   
    let flip =0;
    for(let i=0;i<animations.length;i++){
  
      const arrayBars = document.getElementsByClassName('array-bar');
      if(animations[i].length === 2){
        const [barOneIdx, barTwoIdx] = animations[i];
        const barOneStyle = arrayBars[barOneIdx].style;
        const barTwoStyle = arrayBars[barTwoIdx].style;
        const color = (flip == 0) ? SECONDARY_COLOR : PRIMARY_COLOR;
        flip=flip^1;
        setTimeout(() => {
  
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
  
        }, i * this.state.ANIMATION_SPEED_MS);
        
      }
      else{
  
        setTimeout(() => {
          
          const [t,barOneIdx, barTwoIdx] = animations[i];
          const barOneStyle = arrayBars[barOneIdx].style;
          const barTwoStyle = arrayBars[barTwoIdx].style;
          const newHeight1 = array[barTwoIdx];
          const newHeight2 = array[barOneIdx];
          barOneStyle.height = `${newHeight1}px`;
          barTwoStyle.height = `${newHeight2}px`;
          const temp = array[barOneIdx];
          array[barOneIdx] = array[barTwoIdx];
          array[barTwoIdx] = temp;
          
  
        }, i * this.state.ANIMATION_SPEED_MS);
        
      }

    }

  }
  }


  
  componentDidMount() {
    this.resetArray();
  }


  render() {
    const {array} = this.state;
    return (
      <>
      <div className="navbar-fixed">
      <nav className="nav-wrapper white">
            <div className="container">
            <Link to={this.state.address} className="brand-logo" className={styles.logo}><img src='/img/image.tj9vk9'  alt='logo' /></Link>
                <ul className="right hide-on-med-and-down">
                    <li><a className = "black-text" onClick={() => this.resetArray()}>Reset</a></li>
                    <li><a className = "black-text" onClick={() => this.mergeSort()}>Merge Sort</a></li>
                    <li><a className = "black-text" onClick={() => this.quickSort()}>Quick Sort</a></li>
                    <li><a className = "black-text" onClick={() => this.heapSort()}>Heap Sort</a></li>
                    <li><a className = "black-text" onClick={() => this.bubbleSort()}>Bubble Sort</a></li>
                    <li><a className = "black-text" onClick={() => this.insertionSort()}>Insertion Sort</a></li>
                    <li><a className = "black-text" onClick={() => this.selectionSort()}>Selection sort</a></li>
                   
                </ul>
            </div>
        </nav>
        </div>
       <input
          id="changeSize"
          type="range"
          min="15"
          max="56"
          onChange={this.handleChange}
          />
      <div className="array-container">
     
        <div className={cx("box")}>
        {array.map((value, idx) => (
          <div
            className="array-bar"
            key={idx}
            style={{
              backgroundColor: PRIMARY_COLOR,
              height: `${value}px`,
            }}></div>
        ))}
        </div>
      </div>
      </>
    );
  }
}


function randomIntFromInterval(min, max) {
  
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function arraysAreEqual(arrayOne, arrayTwo) {
  if (arrayOne.length !== arrayTwo.length) return false;
  for (let i = 0; i < arrayOne.length; i++) {
    if (arrayOne[i] !== arrayTwo[i]) {
      return false;
    }
  }
  return true;
}
